import { DataProvider } from '@repo/ui/dataProvider'
import { useEffect } from 'react'

import { Feedbacks } from '@/components/admin/Feedbacks'
import { SkeletonCard } from '@/components/skeletons/SkeletonCard.tsx'
import { RootState } from '@/store'
import { adminStoreActions } from '@/store/actions'
import { Feedback } from '@/store/admin'
import { useStoreDispatch } from '@/store/hooks'
import { Organization } from '@/store/user'

export type FeedbacksProps = {
  feedbacks: Feedback[]
  organizationId: string
}

export function FeedbacksRoute({ organization }: { organization: Organization }) {
  const dispatch = useStoreDispatch()
  useEffect(() => {
    if (organization.chatSettings?.allowFeedback) {
      void dispatch(adminStoreActions.feedback.initFeedbacks())
    }
  }, [])
  if (organization.chatSettings?.allowFeedback)
    return (
      <DataProvider
        loadingComponent={<SkeletonCard />}
        selectors={[(state: RootState) => state.admin.feedbacks]}
        render={(feedbacks) => <Feedbacks organizationId={organization.id} feedbacks={feedbacks} />}
      />
    )
  return null
}
